import React from 'react';
import { ArrowRight, CalendarDays } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import { blogPosts, blogSection } from '../mock/content';

const BlogTeaser = () => {
  const { lang } = useApp();
  const s = blogSection[lang] || blogSection.en;
  const posts = blogPosts.slice(0, 3);
  return (
    <section id="blog" className="py-20 bg-[color:var(--brand-muted)]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-10">
          <div className="max-w-2xl">
            <h2 className="text-3xl sm:text-4xl font-extrabold text-[color:var(--brand-dark)]">{s.title}</h2>
            <p className="mt-4 text-gray-500 leading-relaxed">{s.subtitle}</p>
          </div>
          <Link to="/blog" className="inline-flex items-center gap-2 rounded-full px-5 py-2.5 font-bold text-sm border-2 whitespace-nowrap transition-colors hover:bg-[color:var(--brand-dark)] hover:text-white" style={{ borderColor: 'var(--brand-dark)', color: 'var(--brand-dark)' }}>
            {s.all} <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {posts.map((p) => {
            const loc = p[lang] || p.en;
            return (
              <Link to={`/blog/${p.slug}`} key={p.slug} className="card-hover group bg-white rounded-2xl overflow-hidden flex flex-col">
                <div className="relative h-48 overflow-hidden">
                  <img src={p.img} alt={loc.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
                  <span className="absolute top-3 left-3 text-[11px] font-bold px-2.5 py-1 rounded-full text-white" style={{ backgroundColor: 'var(--brand-accent)' }}>{p.tag}</span>
                </div>
                <div className="p-5 flex flex-col flex-1">
                  <div className="flex items-center gap-1.5 text-xs text-gray-400 mb-2"><CalendarDays className="w-3.5 h-3.5" /> {p.date}</div>
                  <h3 className="font-bold text-[color:var(--brand-dark)] leading-snug">{loc.title}</h3>
                  <p className="mt-2 text-sm text-gray-500 leading-relaxed flex-1">{loc.excerpt}</p>
                  <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-bold text-[color:var(--brand-dark)]">{s.read} <ArrowRight className="w-4 h-4" style={{ color: 'var(--brand-accent-hover)' }} /></span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default BlogTeaser;
